import http from '../../../utils/fetch';
import updownfile from '../../../utils/updownfile';
export default {

    baseurl:'/api/swyl/v1/vw/specialview',

    specialorderviewControllerurl:'/api/swyl/v1/tejiadingdanshitu/viewSpecialOrder',

    getSpByNum(q){
        return http({
            url: this.baseurl + '/getSpByNum',
            method: 'post',
            params: q
        });
    },

    getSpByNumHavePage(q){
        return http({
            url: this.baseurl + '/getSpByNumHavePage',
            method: 'post',
            params: q
        });
    },

    getSpByNumForExcel(vwcode){

        updownfile.down(this.baseurl+'/getSpByNumForExcel',{vwcode:vwcode},"get");

        // window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getSpByNumForExcel?vwcode='+vwcode

    },

    specialorderviewselectPage(q){
        return http({
            url: this.specialorderviewControllerurl + '/selectPage',
            method: 'post',
            params: q
        });
    },

    specialorderviewselectPageCG(q){
        return http({
            url: this.specialorderviewControllerurl + '/selectPageCG',
            method: 'post',
            params: q
        });
    },



}
